import React, { Component } from 'react';
import { ProcessingScreenTakeover } from 'web-ui-components/lib/layout/content';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { Form } from 'react-final-form';
import PropTypes from '../../types';
import { Content } from '../../infrastructure/content';

class SecurityChecksPage extends Component {
  /* TODOxCYBG: Remove unused props if required */

  render() {
    const { saveSecurityChecksForm, getBusinessData, isLoading } = this.props;
    return (
      <Form
        onSubmit={saveSecurityChecksForm}
        initialValues={getBusinessData}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Content>
              {({ securityChecksPageTitle = '', securityChecksLeadPara, securityChecksDone }) => (
                <div>
                  <ProcessingScreenTakeover
                    titleText={isLoading ? securityChecksPageTitle : securityChecksDone}
                  >
                    <StandardBody>
                      <p>{isLoading && securityChecksLeadPara}</p>
                    </StandardBody>
                  </ProcessingScreenTakeover>
                </div>
              )}
            </Content>
          </form>
        )}
      />
    );
  }
}
SecurityChecksPage.propTypes = {
  bankId: PropTypes.bankId.isRequired,
  saveSecurityChecksForm: PropTypes.func
};

export default SecurityChecksPage;
